import { reactive } from "vue";

export const edmState = reactive({
  currentTemplate: undefined,
  currentCampaign: undefined,
  currentEdmId: undefined,
  currentHtml: undefined,
});
